export default __webpack_public_path__ + "741c1fce79493acc8079904865cbf4be.png";